var __webpack_exports__ = {};
/*!**********************************!*\
  !*** ./src/scripts/quick-buy.js ***!
  \**********************************/
class QuickBuy extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-quick-buy-btn]');
    this.cartItems = document.querySelector('cart-items');

    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onClickHandler.bind(this));
  }

  onClickHandler(event) {
    event.preventDefault();

    this.variantIds = this.getAttribute('variant-ids');
    this.properties = this.getAttribute('line-item-props');

    if (!this.variantIds) {
      return;
    }

    this.button.setAttribute('disabled', true);
    this.button.classList.add('loading');

    const quantityEl = this.querySelector('input[name="quantity"]');
    const quantity = (quantityEl) ? parseInt(quantityEl.value) : 1;

    let properties;
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties);
      } catch (err) {
        console.error(err);
      }
    }

    let itemsObj = [];
    const varIdsArr = this.variantIds.split(',');
    varIdsArr.forEach(varId => {
      itemsObj.push({
        id: varId,
        quantity: quantity,
        properties: properties
      });
    });

    let body = {
      items: itemsObj
    };

    if (this.cartItems) {
      body.sections = this.cartItems.getSectionsToRender().map(section => section.id);
      body.sections_url = window.location.pathname;
    }

    body = JSON.stringify(body);

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(parsedState => {
        this.cartItems?.renderContents(parsedState);
        return this.cartItems.checkGifts();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }

}

customElements.define('quick-buy', QuickBuy);

